import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { GdsCommonUtilityService } from '@upr-web-primer/gds-common-utility';
import { get } from 'lodash-es';
class GdsVideoModelModule {
  static {
    this.ɵfac = function GdsVideoModelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsVideoModelModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsVideoModelModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsVideoModelModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class GdsVideoModelService {
  constructor(injector) {
    this.injector = injector;
  }
  get utilities() {
    if (!this._utilities) {
      this._utilities = this.injector.get(GdsCommonUtilityService);
    }
    return this._utilities;
  }
  init(field, isXpath) {
    return {
      desktop: this.utilities.getImageUrl(field, 'desktop', true, 0, isXpath),
      mobile: this.utilities.getImageUrl(field, 'mobile', true, 0, isXpath),
      tablet: this.utilities.getImageUrl(field, 'tablet', true, 0, isXpath),
      backgroundColor: get(field, 'EmbeddedValues[0].backgroundColor.Values[0]')
    };
  }
  static {
    this.ɵfac = function GdsVideoModelService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsVideoModelService)(i0.ɵɵinject(i0.Injector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsVideoModelService,
      factory: GdsVideoModelService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsVideoModelService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i0.Injector
  }], null);
})();

/*
 * Public API Surface of gds-video-model
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsVideoModelModule, GdsVideoModelService };
